import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ICON_INFO, ICON_CANCEL } from '../../extras/icons';
//Función principal
const MotiveModal = props => {
    //Tomo los props
    const { audience, title, subtitle, show, handleClose } = props;
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header>
                <Modal.Title>
                    <ICON_INFO />&nbsp;
                    { title }
                    {
                        subtitle ? (
                            <React.Fragment>
                                &nbsp;
                                <small>{ subtitle }</small>
                            </React.Fragment>
                        ) : null
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    {
                        audience ? (
                            <div className="col-md-12 text-center">
                                <strong>{ audience.motivo ? audience.motivo.descripcion : ''}</strong>
                                <br/>
                                <p>{ audience.observacionRechazo }</p>
                            </div>
                        ) : null
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MotiveModal;